//@ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { FormHelperText } from '@material-ui/core';
import Autocomplete from 'react-google-autocomplete';
import { useIntl } from 'react-intl';
import { ILocation } from '../../../interfaces/locations';
import { colors } from '../../../constants/colors';
import { Location } from 'react-iconly';
import { useStyles } from './hooks/useStyles';
import './AutoComplete.sass';
interface IProps {
  value: { address: string };
  error?: boolean;
  helperText?: string;
  setSelectedLocation: (data: ILocation) => void;
  disabled?: boolean;
  rootClassName?: any;
}

const REACT_APP_GOOGLE_API_KEY = 'AIzaSyB_rjiR94heML-tlGsexMmxwtpVQ7WlcxI';

const AutocompleteCopy: React.FC<IProps> = ({
  value,
  setSelectedLocation,
  error,
  helperText,
  disabled,
  rootClassName,
}) => {
  const intl = useIntl();
  const classes = useStyles();
  const outlineBorder: { [key: string]: string } = {
    default: colors.complementary.green,
    error: colors.primary.red,
    focus: colors.primary.green,
  };
  const ref = useRef<any>();

  const [type, setType] = useState<string>('default');
  const [borderWidth, setBorderWidth] = useState(1);
  useEffect(() => {
    setType(error ? 'error' : 'default');
  }, [error]);

  useEffect(() => {
    if (value.address && !ref.current.value) {
      ref.current.value = value.address;
    }
  }, [value]);

  return (
    <div className={`${classes.root} ${rootClassName}`}>
      {disabled ? (
        <div
          className={classes.input}
          style={{
            boxShadow: `inset 0 0 0 1px #c4c4c4`,
          }}
        >
          {value.address ||
            intl.formatMessage({
              id: 'STORE.INPUT.LOCATION',
            })}
        </div>
      ) : (
        <>
          <i className={classes.locationIcon}>
            <Location set="bold" primaryColor={colors.primary.green} />
          </i>
          <Autocomplete
            className={classes.input}
            placeholder={'Enter the city and delivery address'}
            style={{
              boxShadow: `inset 0 0 0 ${borderWidth}px ${outlineBorder[type]}`,
              background: 'transparent',
            }}
            onFocus={() => {
              setBorderWidth(2);
              setType(error ? 'error' : 'focus');
            }}
            onBlur={() => {
              setBorderWidth(1);
              setType(error ? 'error' : 'default');
            }}
            options={{
              types: ['geocode', 'establishment'],
              componentRestrictions: { country: 'AU' },
            }}
            language="en"
            apiKey={REACT_APP_GOOGLE_API_KEY}
            onPlaceSelected={(place) => {
              if (
                place.formatted_address &&
                place.geometry.location.lat &&
                place.geometry.location.lng
              ) {
                setSelectedLocation({
                  address: place.formatted_address,
                  lat: place.geometry.location.lat(),
                  lng: place.geometry.location.lng(),
                } as ILocation);
              } else {
                setSelectedLocation({} as ILocation);
              }
            }}
            defaultValue={value.address || ''}
            ref={ref}
          />
          {!!value.address ? (
            <svg
              className={classes.clearIcon}
              onClick={() => {
                setSelectedLocation({ address: '', lat: 0, lng: 0 } as ILocation);
                ref.current.value = '';
              }}
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.5002 0.083252C8.43995 0.083252 6.42599 0.694179 4.71298 1.83878C2.99997 2.98337 1.66484 4.61024 0.876422 6.51363C0.0880094 8.41703 -0.118275 10.5115 0.283654 12.5321C0.685583 14.5527 1.67767 16.4088 3.13447 17.8656C4.59127 19.3224 6.44734 20.3145 8.46798 20.7164C10.4886 21.1184 12.5831 20.9121 14.4865 20.1237C16.3899 19.3353 18.0167 18.0001 19.1613 16.2871C20.3059 14.5741 20.9168 12.5601 20.9168 10.4999C20.9168 9.13198 20.6474 7.77744 20.1239 6.51363C19.6004 5.24982 18.8331 4.1015 17.8659 3.13422C16.8986 2.16695 15.7503 1.39966 14.4865 0.876173C13.2226 0.352687 11.8681 0.083252 10.5002 0.083252ZM13.3231 11.8437C13.4207 11.9405 13.4982 12.0557 13.5511 12.1827C13.604 12.3096 13.6312 12.4457 13.6312 12.5833C13.6312 12.7208 13.604 12.8569 13.5511 12.9839C13.4982 13.1108 13.4207 13.226 13.3231 13.3228C13.2262 13.4205 13.111 13.498 12.9841 13.5508C12.8572 13.6037 12.721 13.631 12.5835 13.631C12.446 13.631 12.3098 13.6037 12.1829 13.5508C12.056 13.498 11.9408 13.4205 11.8439 13.3228L10.5002 11.9687L9.15642 13.3228C9.05958 13.4205 8.94437 13.498 8.81744 13.5508C8.6905 13.6037 8.55435 13.631 8.41683 13.631C8.27932 13.631 8.14317 13.6037 8.01623 13.5508C7.8893 13.498 7.77409 13.4205 7.67725 13.3228C7.57962 13.226 7.50212 13.1108 7.44924 12.9839C7.39635 12.8569 7.36913 12.7208 7.36913 12.5833C7.36913 12.4457 7.39635 12.3096 7.44924 12.1827C7.50212 12.0557 7.57962 11.9405 7.67725 11.8437L9.03142 10.4999L7.67725 9.15617C7.4811 8.96002 7.37091 8.69398 7.37091 8.41658C7.37091 8.13919 7.4811 7.87315 7.67725 7.677C7.8734 7.48085 8.13944 7.37066 8.41683 7.37066C8.69423 7.37066 8.96027 7.48085 9.15642 7.677L10.5002 9.03117L11.8439 7.677C12.0401 7.48085 12.3061 7.37066 12.5835 7.37066C12.8609 7.37066 13.1269 7.48085 13.3231 7.677C13.5192 7.87315 13.6294 8.13919 13.6294 8.41658C13.6294 8.69398 13.5192 8.96002 13.3231 9.15617L11.9689 10.4999L13.3231 11.8437Z"
                fill="#7CB142"
              />
            </svg>
          ) : null}

          {!!helperText && (
            <FormHelperText style={{ margin: '3px 14px 0px' }} error={error}>
              {helperText}
            </FormHelperText>
          )}
        </>
      )}
    </div>
  );
};

export default AutocompleteCopy;
